import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  return <section className="bg-gradient-to-br from-[#FFF3E0] via-light-bg to-[#E8F5E9] text-center py-12 md:py-16 px-5 border-b-4 border-accent" data-id="element-249">
      <div className="max-w-4xl mx-auto" data-id="element-250">
        {/* Pre-headline: Pattern Interrupt */}
        <div className="mb-6" data-id="element-251">
          <span className="inline-block bg-amber-50 border border-amber-300 rounded-full px-4 py-1.5 text-sm md:text-base font-bold text-amber-800 shadow-sm" data-id="element-252">
            ⚠️ Para Mamás y Papás Que Sienten Que No Están Haciendo Lo
            Suficiente...
          </span>
        </div>

        {/* Headline: Transformation & Bold */}
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[52px] leading-tight font-black text-dark max-w-4xl mx-auto mb-6" data-id="element-253">
          Deja de Adivinar y Empieza a Saber{' '}
          <span className="bg-[#FFF176] px-2 decoration-clone box-decoration-clone" data-id="element-254">
            EXACTAMENTE
          </span>{' '}
          Qué Necesita Tu Hijo Para Desarrollar{' '}
          <span className="bg-[#FFF176] px-2 decoration-clone box-decoration-clone" data-id="element-255">
            Todo Su Potencial
          </span>
        </h1>

        {/* Emotional Bridge: Handwritten */}
        <p className="font-handwritten text-2xl md:text-3xl text-primary-dark font-bold mb-8 -mt-2" data-id="element-256">
          Porque los primeros 5 años no se repiten... y tú lo sabes.
        </p>

        {/* Subheadline: The Solution */}
        <p className="font-sans text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-257">
          Descubre el sistema paso a paso con{' '}
          <span className="font-bold text-primary" data-id="element-258">+1.000 actividades</span>{' '}
          organizadas mes a mes que te dicen exactamente qué hacer, con qué
          materiales (que ya tienes en casa), y en solo{' '}
          <span className="font-bold text-dark" data-id="element-259">10 minutos al día</span> — sin
          pantallas, sin estrés, sin culpa.
        </p>

        {/* Video Placeholder */}
        <div className="bg-dark text-gray-400 max-w-2xl mx-auto mb-6 py-10 px-5 rounded-xl shadow-2xl" data-id="element-260">
          <p className="font-sans text-sm mb-4" data-id="element-261">
            (Asegúrate de tener el sonido activado. El vídeo puede tardar unos
            segundos en cargar)
          </p>
          <p className="text-4xl mb-4" data-id="element-262">▶</p>
          <p className="font-sans text-base text-gray-300" data-id="element-263">
            Mira Este Vídeo Hasta el Final y Obtén Acceso al Pack Completo
          </p>
        </div>

        {/* Price Display */}
        <div className="font-sans text-base md:text-lg text-gray-600 mb-4" data-id="element-264">
          Oferta por Tiempo Limitado:{' '}
          <PriceDisplay amount={36} className="line-through text-gray-400" data-id="element-265" />{' '}
          <PriceDisplay amount={12.99} className="text-primary font-black text-2xl md:text-3xl ml-2" data-id="element-266" />
        </div>

        {/* CTA Button */}
        <div className="my-8" data-id="element-267">
          <CtaButton subtitle="Acceso Inmediato a +1.000 Actividades >>" data-id="element-268">
            Añadir Al Carrito
          </CtaButton>
        </div>

        {/* Fine Print */}
        <p className="font-sans text-sm text-gray-500 max-w-lg mx-auto" data-id="element-269">
          Pago único. Sin suscripciones. Sin cargos ocultos.
          <br data-id="element-270" />
          Me reservo el derecho de cerrar esta oferta en cualquier momento
          después del 25 de febrero de 2026.
        </p>
      </div>
    </section>;
}